/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StorageFile { 
    /**
     * The fully qualified file path to the data. When Storage Directory is specified, all Storage File paths should start with the                   Storage Directory path                
     */
    filePath: string;
    /**
     * The file size in bytes
     */
    fileSizeBytes?: number;
    /**
     * The number of lines in the file
     */
    rowCount?: number;
}
